"use strict";
// generated_funding_request.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: zod_1.z.string().describe('Credit facility slug'),
    description: zod_1.z.string().describe('Description'),
    fundingSubmissionComponentsArtifactSlug: zod_1.z
        .string()
        .optional()
        .describe('Use if passing known funding request amounts + target dates. Created funding request will automatically be submitted. CSV with 3 columns: "type" (i.e. funding request component type), "totalAmount", "targetFundingDate".'),
});
exports.nodeType = 'file_generatedFundingRequest';
exports.artifactType = 'fundingRequest';
//# sourceMappingURL=types.js.map